import {Part} from './part';
import {OrganizationAddress} from "../organization/organization-address";

export class PartSearchResult {

  searchTerm!: string;
  orderInfo!: string;
  warranty!: boolean;
  parts!: Part[];
  warrantyRequestNotes!: string;
  defectCodeId!: number;
  failureDate!: Date;
  installDate!: Date;
  miles!: string;
  dealerAddressId!: string;


}
